import { createSlice } from '@reduxjs/toolkit';

export interface AclState {
	isLoading: boolean;
	patientDiagnosis: [];
}

const initialState: AclState = {
	isLoading: false,
	patientDiagnosis: [],
};

export const patientMetaSlice = createSlice({
	name: 'patientMeta',
	initialState,
	reducers: {
		setPatientMetaIsLoading: (state, { payload }) => {
			state.isLoading = payload;
		},
		setPatientDiagnosis: (state, { payload }) => {
			state.patientDiagnosis = payload;
		},
	},
});

export const { setPatientMetaIsLoading, setPatientDiagnosis } =
	patientMetaSlice.actions;
export const selectPatientMetaIsLoading = (state: any) =>
	state.patientMeta.isLoading;
export const selectPatientDiagnosis = (state: any) =>
	state.patientMeta.patientDiagnosis;

export default patientMetaSlice.reducer;
